const getters = {
  token: state => state.user.token,
  info: state => {
    return state.user.info
  },
  config: state => state.config.config
}
export default getters
